import React from "react";
import casaRemota from "../../assets/images/casaRemota.png";
import casaAluguel from "../../assets/images/casaAluguel.png";
import solPreto from "../../assets/images/solPreto.png";

export function SolCasaUc(props) {
    const uc = props.uc;
    if (!uc) return null;

    if (uc.geradora_e_remota && uc.possui_contrato_aluguel) {
        return (
            <div title={`Geradora que aluga energia de outra usina`}>
                <img alt="" height={28} style={{ marginBottom: 6 }} src={solPreto}></img>
                <img alt="" height={28} style={{ marginBottom: 6 }} src={casaAluguel}></img>
            </div>
        );
    }
    if (uc.geradora_e_remota && !uc.possui_contrato_aluguel) {
        return (
            <div title={`Geradora que recebe energia de outra usina própria`}>
                <img alt="" height={28} style={{ marginBottom: 6 }} src={solPreto}></img>
                <img alt="" height={28} style={{ marginBottom: 6 }} src={casaRemota}></img>
            </div>
        );
    }

    if (!uc.geradora_e_remota && uc.geracao) {
        return <img alt="" title={"Unidade Consumidora Geradora"} height={28} style={{ marginBottom: 6 }} src={solPreto}></img>;
    }

    if (!uc.geradora_e_remota && uc.remota) {
        return <img alt="" title={"Unidade Consumidora Remota"} height={28} style={{ marginBottom: 6 }} src={casaRemota}></img>;
    }

    if (uc.remota && uc.possui_contrato_aluguel) {
        return <img alt="" title={"Unidade Consumidora Remota que aluga energia"} height={28} style={{ marginBottom: 6 }} src={casaAluguel}></img>;
    }

    return null;
}
